export const playNotificationSound = () => {
    let audio = new Audio('/audio/notification.wav');

    audio.play()
        .then(() => {
            audio = null;
        })
        .catch(console.error)
        .finally(() => {
            audio = null;
        });
}

export const playExpressNotificationSound = () => {
    let audio = new Audio('/audio/express.wav');

    audio.play()
        .then(() => {
            audio = null;
        })
        .catch(console.error)
        .finally(() => {
            audio = null;
        });

    return audio;
}
